import { render, staticRenderFns } from "./data-link.vue?vue&type=template&id=3695637d&scoped=true"
import script from "./data-link.vue?vue&type=script&lang=js"
export * from "./data-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695637d",
  null
  
)

export default component.exports